// Stub implementation

<template>
  <div class="content-aligned">
    <h1>Contents</h1>

    <div id="contents-modal-contents">
      <p><i>… contents loading …</i></p>
    </div>
  </div>
</template>
